/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useGetNotificationDataInternal = makeQueryHook(
  operations.getNotificationDataInternal,
)

export const useGetNotificationTypesByCompany = makeQueryHook(
  operations.getNotificationTypesByCompany,
)

export const useGetProductsWithNotifications = makeQueryHook(
  operations.getProductsWithNotifications,
)

export const useGetSubjectsWithNotifications = makeQueryHook(
  operations.getSubjectsWithNotifications,
)

export const useGetTriggersWithNotifications = makeQueryHook(
  operations.getTriggersWithNotifications,
)

export const useGetNotificationTypesInternal = makeQueryHook(
  operations.getNotificationTypesInternal,
)

export const useCreateNotificationTypeInternal = makeMutationHook(
  operations.createNotificationTypeInternal,
)

export const useGetNotificationTypeById = makeQueryHook(
  operations.getNotificationTypeById,
)

export const useUpdateNotificationTypeInternal = makeMutationHook(
  operations.updateNotificationTypeInternal,
)

export const useDeleteNotificationTypeInternal = makeMutationHook(
  operations.deleteNotificationTypeInternal,
)
